import { render, staticRenderFns } from "./ShowResults.vue?vue&type=template&id=b97d572a&"
import script from "./ShowResults.vue?vue&type=script&lang=js&"
export * from "./ShowResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports